import React, { useContext, useEffect } from 'react';
import utils from '../utils';
import InputBox from '../InputBox';
import ModifySearchContext from '../ModifySearchContext';
import PaxPickerV2 from './PaxPickerV2';
import PaxPicker from './PaxPicker';
import ModifySearchHeader from '../ModifySearchHeader';

const SelectPax = ({
  label = 'ROOMS & GUESTS',
  value = '',
  handleChange,
  name = '',
  next = false,
  roomAdditionAllowed,
  onFocus,
  roomsAndGuestsError = false,
  openBox = null,
  searchButtonClicked = false,
  setsearchButtonClicked,
  roomsAndGuestsErrorMessage = '',
  closeAfterApply = false,
  paxConfig,
  omniture,
  showNewPaxPicker = false,
  warningMessage,
  icon,
}) => {
  const { setActiveControl } = useContext(ModifySearchContext);
  useEffect(() => {
    if (openBox !== null) {
      setActiveControl(openBox);
      setsearchButtonClicked(false);
    }
  }, [openBox, searchButtonClicked]);

  const handlePaxChange = pax => {
    if (closeAfterApply) {
      setActiveControl(null);
    }
    handleChange(utils.modifyPaxFormat(pax, paxConfig));
  };

  value = utils.demodifyPaxFormat(value, paxConfig);
  return (
    <InputBox
      name={name}
      value={utils.getDisplayValue('paxpicker', value)}
      label={label}
      onFocus={onFocus}
      icon={icon}
    >
      <ModifySearchHeader title="Select Guests & Rooms" />
      {showNewPaxPicker ? (
        <PaxPickerV2
          value={value}
          handleChange={handlePaxChange}
          roomAdditionAllowed={roomAdditionAllowed}
          roomsAndGuestsError={roomsAndGuestsError}
          roomsAndGuestsErrorMessage={roomsAndGuestsErrorMessage}
          paxConfig={paxConfig}
          omniture={omniture}
          warningMessage={warningMessage}
        />
      ) : (
        <PaxPicker
          value={value}
          handleChange={handlePaxChange}
          roomAdditionAllowed={roomAdditionAllowed}
          roomsAndGuestsError={roomsAndGuestsError}
          roomsAndGuestsErrorMessage={roomsAndGuestsErrorMessage}
          paxConfig={paxConfig}
        />
      )}
    </InputBox>
  );
};

export default SelectPax;
